import PropTypes from 'prop-types';
import React from 'react';
import CalendarTask from './CalendarTask';

/**
 * @callback onAction
 */

/**
 * @callback onExpandCb
 * @param {boolean} expanded
 */
/**
 * Calendar workflow tasks
 * @param {moment} day
 * @param {Array<Moment>} range
 * @param {Array<MRB.ActionItem> | null} tasks
 * @param {boolean} expanded
 * @param {onExpandCb} onExpand
 * @param {onAction} onAction
 */
function CalendarBodyLineTasks({ day, range, tasks, expanded, onExpand, onAction, isPermissionAvailable, moveInDate}) {
  return (
    <>
      {tasks?.map((task) => (
        <CalendarTask key={task.id} task={task} expanded={expanded} onExpand={onExpand} onAction={onAction} day={day} range={range} isPermissionAvailable={isPermissionAvailable} moveInDate={moveInDate} actionItems = {tasks}/>
      ))}
    </>
  );
}

CalendarBodyLineTasks.propTypes = {
  day: PropTypes.any,
  range: PropTypes.array,
  tasks: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  expanded: PropTypes.bool,
  onExpand: PropTypes.func,
  isPermissionAvailable: PropTypes.func,
  moveInDate: PropTypes.any,
};

export default React.memo(CalendarBodyLineTasks);
